export default {
    "flashcards.title": "Interactive",
    "flashcards.title_highlight": "Flashcards",
    "flashcards.subtitle": "Memorize key dates and facts using spaced repetition.",

    "flashcards.nav.back_themes": "Back to themes",
    "flashcards.nav.download_pdf": "Download PDF",
    "flashcards.nav.flip_question": "See question",
    "flashcards.nav.flip_answer": "See answer",

    "flashcards.card.question": "QUESTION",
    "flashcards.card.answer": "ANSWER",
    "flashcards.card.click_flip": "Click to flip",

    "flashcards.status.no_flashcards": "No flashcards available",
    "flashcards.status.no_flashcards_desc": "Flashcards for this category are coming soon!",
    "flashcards.status.back": "Back",

    "flashcards.result.title": "Session complete!",
    "flashcards.result.subtitle": "Well done! You reviewed all cards in this theme.",
    "flashcards.result.retry": "Restart",
    "flashcards.result.other_theme": "Choose another theme",
    "flashcards.result.unlock_pro": "UNLOCK FULL ACCESS",
    "flashcards.result.unlock_pro_desc": "Access all cards and themes.",

    "flashcards.badges.new": "New Badge!",
    "flashcards.badges.congrats": "Congratulations on your perseverance.",
    "flashcards.badges.close": "Continue",

    "flashcards.pdf.title": "Flashcards - {{theme}}",
    "flashcards.pdf.footer": "Document generated by CitoyenPro - citoyenpro.nnt-quebec.com",
    "flashcards.pdf.label_answer": "Answer"
};
